import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import invoicesList from "./invoices";
import helpersNumbers from "../../../helpers/numbers";

export default function Invoices() {
  const generateTagAllInvoices = () => {
    return (
      <>
        <div className="alert alert-warning ">
          <p>
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p>
                لیست فاکتور‌ها و پیش‌فاکتور‌های شما در این صفحه نمایش داده
                میشود.
              </p>
            </li>
            <li>
              <p>
                در این بخش شما میتوانید از بخش مشاهده پیش فاکتور درخواست فاکتور
                رسمی نمایید.
              </p>
            </li>
          </ul>
        </div>
        <div className="table-responsive pt-3">
          <table className="table table-hilite tbl-td-white-space table-hover mb-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره فاکتور</td>
                <td>مبلغ پرداخت (تومان)</td>
                <td>کد پیگیری</td>
                <td>مبلغ شارژ (تومان)</td>
                <td>تاریخ پرداخت</td>
                <td>فاکتور رسمی</td>
                <td>مشاهده پیش فاکتور</td>
              </tr>
            </thead>
            <tbody>{generateItemsInvoice(invoicesList)}</tbody>
          </table>
        </div>
      </>
    );
  };

  const generateItemsInvoice = () => {
    return invoicesList.map((invoice, index) => {
      return (
        <tr key={index}>
          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
          <td>{helpersNumbers.toPersianNum(invoice.id)}</td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(invoice.amount)
            )}
          </td>
          <td>{invoice.reference}</td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(
                Math.floor(
                  (invoice.amount * 100) /
                    (100 +
                      parseInt(process.env.REACT_APP_TAX_PERCENT_AMOUNT_CHARGE))
                )
              )
            )}
          </td>
          <td dir="ltr">{helpersNumbers.toPersianNum(invoice.paid_at)}</td>
          <td>
            {invoice.send_invoice ? (
              <span className="badge badge-success">صادر شده</span>
            ) : (
              <span className="badge badge-danger">صادر نشده</span>
            )}
          </td>
          <td>
            <Link to={`/finance/official/${invoice.id}`}>
              <span className="btn btn-info">
                <i className="fa fa-eye"></i>
              </span>
            </Link>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <Sidebar openItem="all-finance" activeItem="invoices-finance" />

      <div className="content-wrapper">
        <TitleBar title="فاکتورها و پیش فاکتورها" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">{generateTagAllInvoices()}</div>
          </div>
        </section>
      </div>
    </>
  );
}
